import React from 'react';

import { BrandPendulumMark } from './BrandPendulumMark';

import './SignupCreditAwardModal.css';

interface CreditRewardContentProps {
  titleId: string;
  messageId?: string;
  title: string;
  eyebrow: string;
  amount: number | null;
  creditDescription: string;
  message: string;
  actionLabel: string;
  closeLabel: string;
  busy?: boolean;
  onAction: () => void;
  onClose: () => void;
  secondaryAction?: { label: string; onClick: () => void };
}

const CreditRewardAmount: React.FC<{ amount: number; description: string }> = ({ amount, description }) => {
  const formattedAmount = new Intl.NumberFormat().format(amount);

  return (
    <div aria-label={`${formattedAmount} credits ${description}`} className="signup-credit-award-credit">
      <span className="signup-credit-award-gift" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13" />
          <path d="M12 8H8.5A2.5 2.5 0 1 1 11 5.5L12 8Zm0 0h3.5A2.5 2.5 0 1 0 13 5.5L12 8Z" />
        </svg>
      </span>
      <div className="signup-credit-award-amount"><strong>{formattedAmount}</strong><span>free credits</span></div>
      <small>{description}</small>
    </div>
  );
};

export const CreditRewardContent: React.FC<CreditRewardContentProps> = ({
  titleId, messageId, title, eyebrow, amount, creditDescription, message, actionLabel, closeLabel,
  busy = false, onAction, onClose, secondaryAction,
}) => (
  <>
    <button aria-label={closeLabel} className="signup-credit-award-close" disabled={busy}
      onClick={onClose} type="button">×</button>
    <div aria-hidden="true" className="signup-credit-award-brand">
      <BrandPendulumMark className="signup-credit-award-brand-mark" />
      <span>8080.AI</span>
    </div>
    <p className="signup-credit-award-eyebrow">{eyebrow}</p>
    <h2 id={titleId}>{title}</h2>
    {amount !== null && <CreditRewardAmount amount={amount} description={creditDescription} />}
    <p className="signup-credit-award-message" id={messageId} aria-live="polite">{message}</p>
    <button className="signup-credit-award-button" disabled={busy} onClick={onAction} type="button">
      {actionLabel}
    </button>
    {secondaryAction && <button className="signup-credit-award-secondary-button" disabled={busy}
      onClick={secondaryAction.onClick} type="button">{secondaryAction.label}</button>}
  </>
);
